"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValue = void 0;
var LOCATION_TYPE = 'GeoCoordinates';
function geoToFixed(pos) {
    if (pos !== null && pos !== undefined && pos !== '' && !Number.isNaN(pos)) {
        return (Math.round(Number(pos) * 1000) / 1000.0).toFixed(3);
    }
}
/**
 * Create a valid Location object according to schema. Will create the
 * required '@type' field, and reduce `latitude` and `longitude` accuracy
 * to 3 decimal places.
 *
 * "altitude" is dropped from the result.
 *
 * Other input will be merged with the object as is.
 *
 * @see https://github.schibsted.io/spt-dataanalytics/event-formats/blob/master/schema/master/objects/GeoCoordinates.json
 */
function location(input) {
    var locationInput = (input || {}).location;
    var _a = locationInput || {}, lat = _a.latitude, long = _a.longitude, _ = _a.altitude, rest = __rest(_a, ["latitude", "longitude", "altitude"]); // "altitude" is dropped
    var latitude = geoToFixed(lat);
    var longitude = geoToFixed(long);
    if (latitude || longitude) {
        return __assign(__assign({ '@type': LOCATION_TYPE }, rest), { latitude: latitude, longitude: longitude });
    }
}
exports.default = location;
function defaultValue() {
    return undefined;
}
exports.defaultValue = defaultValue;
